import { render, staticRenderFns } from "./Joinus.vue?vue&type=template&id=2dd0f154&scoped=true&lang=pug&"
import script from "./Joinus.vue?vue&type=script&lang=js&"
export * from "./Joinus.vue?vue&type=script&lang=js&"
import style0 from "./Joinus.vue?vue&type=style&index=0&id=2dd0f154&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd0f154",
  null
  
)

export default component.exports